import '../styles/messenger.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { IoMdSend } from "react-icons/io";
import SubNav from '../components/subNav';
import { IoMdCloseCircleOutline } from "react-icons/io";
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { IoIosSettings } from "react-icons/io";
import { MdGroupAdd } from "react-icons/md";
import { HiMiniMagnifyingGlass } from "react-icons/hi2";
import { IoMdArrowDropright } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { TiContacts } from "react-icons/ti";
import { BsChatSquareText } from "react-icons/bs";
import { format, isToday, isYesterday } from "date-fns";
import { FaRegCheckCircle } from "react-icons/fa";
import { MdUpload } from "react-icons/md";
import { SiGoogledocs } from "react-icons/si";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GrDocumentPdf } from "react-icons/gr";
import { IoMdDownload } from "react-icons/io";
import byteSize from 'byte-size';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import { baseUrl, R2_PUBLIC_URL, FILE_SERVICE_URL } from '../config';
import { useParams } from 'react-router-dom';

// Configure PDF.js worker for react-pdf 9.x
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

// PDF Preview Component
const PDFPreview = ({ file, filename }) => {
    const [numPages, setNumPages] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setError(false);
        setLoading(false);
    }

    function onDocumentLoadError(error) {
        setError(true);
        setLoading(false);
    }

    if (error) {
        return (
            <div className="pdf-preview-fallback">
                <GrDocumentPdf className='pdfPreviewIcon' />
                <p className='documentFileName'>{filename}</p>
            </div>
        );
    }

    return (
        <div className="pdf-preview-wrapper">
            <Document
                file={file}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
                loading={
                    <div className="pdf-loading">
                        <GrDocumentPdf className='pdfPreviewIcon' />
                        <p>Loading preview...</p>
                    </div>
                }
            >
                <Page
                    pageNumber={1}
                    width={220}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                />
            </Document>
            {numPages > 1 && (
                <div className="pdf-page-indicator">
                    <p>1 / {numPages} pages</p>
                </div>
            )}
            <p className='documentFileName'>{filename}</p>
        </div>
    );
};

/**
 * ✅ Safe file type checker
 */
function safeFileType(fileTypeString) {
    if (!fileTypeString || fileTypeString === null || fileTypeString === "null") {
        return {
            category: "unknown",
            mimeType: "application/octet-stream"
        };
    }

    try {
        const parts = fileTypeString.split("/");
        return {
            category: parts[0] || "unknown",
            mimeType: fileTypeString
        };
    } catch (error) {
        return {
            category: "unknown",
            mimeType: "application/octet-stream"
        };
    }
}

/**
 * ✅ Force download without preview
 */
function handleDownload(url, filename) {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(error => console.error('Download error:', error));
}

/**
 * ✅ NEW: Generate avatar for groups without logos
 */
const generateGroupAvatar = (groupName) => {
    const firstLetter = groupName.charAt(0).toUpperCase();
    const colors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
        '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788'
    ];
    const colorIndex = groupName.charCodeAt(0) % colors.length;
    
    return (
        <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: colors[colorIndex],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: 'white',
            borderRadius: '50%'
        }}>
            {firstLetter}
        </div>
    );
};

export default function Messenger() {
    const [chatName, setChatName] = useState('');
    const [chatImage, setChatImage] = useState(null);
    const [recipients, setRecipients] = useState([]);
    const [recipient, setRecipient] = useState("");
    const [recipientsUsernames, setRecipientsUsernames] = useState([]);
    const recipientInp = useRef(null);
    const [addRecipientResponse, setAddRecipientsResponse] = useState("");
    const navigate = useNavigate();
    const [chats, setChats] = useState([]);
    const [messages, setMessages] = useState([]);
    const [content, setContent] = useState("");
    const messageContents = useRef(null);
    const [searchResults, setSearchResults] = useState("")
    const searchResultInp = useRef(null);
    const chat_name = useRef(null);
    const chat_logo = useRef(null);
    const groupID = useRef(null);
    const imgUpload = useRef(null);
    const [activeGroupId, setActiveGroupId] = useState(0);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [activeUser, setActiveUser] = useState(0);
    const recipientInput = useRef([]);
    const [recipientAddError, setRecipientAddError] = useState("");
    const [currentChat, setCurrentChat] = useState([]);
    const [currentChatIndex, setCurrentChatIndex] = useState([]);
    let chatDetails;
    let chatItems;
    const [preChangeGroup, setPreChangeGroup] = useState([]);
    const [groupResults, setGroupResults] = useState(0);
    const [contacts, setContacts] = useState([]);
    const [generalContacts, setGeneralContacts] = useState([]);
    const [startChatError, setStartChatError] = useState('');
    const [contactsOpen, setContactsOpen] = useState(false);
    const [userSearch, setUserSearch] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [messageFile, setMessageFile] = useState(null);
    const [messageError, setMessageError] = useState(null);
    const [file, setFile] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const { userId } = useParams();
    const [ran, setRan] = useState(false);
    const [loadingGroups, setLoadingGroups] = useState(true)

    const [previewModal, setPreviewModal] = useState({
        isOpen: false,
        type: null,
        url: null,
        filename: null
    });

    let fileEventSource = useRef(null);

    // Optimize content change handler to prevent re-renders
    const handleContentChange = useCallback((e) => {
        setContent(e.target.value);
    }, []);

    useEffect(() => {
        if (userId !== undefined && !ran) {
            startChatParam(userId)
            setRan(true);
        }
        getGroups()
    }, []);

    useEffect(() => {
        if (activeGroupId && activeGroupId !== 0) {
            fileEventSource.current = new EventSource(`${FILE_SERVICE_URL}/api/sse/subscribe/group/${activeGroupId}`);

            fileEventSource.current.addEventListener('file_created', (e) => {
                const fileData = JSON.parse(e.data);
                getMessages(activeGroupId);
            });

            fileEventSource.current.addEventListener('file_deleted', (e) => {
                const data = JSON.parse(e.data);
                getMessages(activeGroupId);
            });

            fileEventSource.current.onerror = (error) => {
            };
        }

        return () => {
            if (fileEventSource.current) {
                fileEventSource.current.close();
            }
        };
    }, [activeGroupId]);

    async function makeAdmin(user_id, group_id, chatIndex, index) {
        const c = chats.map((chat) => {
            return chat;
        });
        c[chatIndex].recipients[index].isAdmin = true;
        setChats(c);
        const response = await fetch(`${baseUrl}/makeAdmin`, {
            method: "POST",
            headers: {
                user_id: user_id,
                group_id: group_id
            },
        })
        if (response.ok) {
        } else {
        }
    }

    async function getRecipients(user_id) {
        const response = await fetch(`${baseUrl}/getUsernameById`, {
            headers: {
                user_id: user_id,
            }
        });
        return await response.json();
    }

    async function getGroups() {
        setLoadingGroups(true);
        setChats([]);
        setContacts([]);

        try {
            const userId = await fetch(`${baseUrl}/getUserIDByToken`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
            });

            if (!userId.ok) {
                navigate("/login");
                return;
            }

            const id = await userId.json();
            setActiveUser(id.user_id);

            const response = await fetch(`${baseUrl}/getGroupsByUserId`, {
                headers: {
                    user_id: id.user_id,
                },
            });

            const groups = await response.json();
            const chatArray = [];
            const allContacts = new Map();

            for (const element of groups) {
                const [groupResponse, recipientsResponse] = await Promise.all([
                    fetch(`${baseUrl}/groupById`, {
                        headers: { group_id: element.group_id }
                    }),
                    fetch(`${baseUrl}/getRecipientsByGroupId`, {
                        headers: { group_id: element.group_id }
                    })
                ]);

                const [groupData, recipientData] = await Promise.all([
                    groupResponse.json(),
                    recipientsResponse.json()
                ]);

                const chat = groupData;

                const admins = await fetch(`${baseUrl}/getAdmins`, {
                    headers: { group_id: chat.group_id }
                });
                const adminData = await admins.json();
                chat.admins = adminData.map(admin => admin.user_id);

                chat.recipients = [];
                for (const recipient of recipientData) {
                    const [recipientDetails, adminStatus] = await Promise.all([
                        getRecipients(recipient.user_id),
                        fetch(`${baseUrl}/isAdmin`, {
                            headers: {
                                user_id: recipient.user_id,
                                group_id: chat.group_id
                            }
                        }).then(res => res.json())
                    ]);

                    const recipientInfo = {
                        userId: recipient.user_id,
                        isAdmin: adminStatus,
                        username: recipientDetails.username
                    };

                    chat.recipients.push(recipientInfo);

                    if (recipient.user_id !== id.user_id && !allContacts.has(recipient.user_id)) {
                        allContacts.set(recipient.user_id, recipientInfo);
                    }
                }

                const messages = await fetch(`${baseUrl}/getMessage`, {
                    headers: { group_id: element.group_id }
                });
                const messageData = await messages.json();
                chat.latestMessage = messageData.length > 0 ? messageData[messageData.length - 1].content : null;
                if (messageData.length > 0 && messageData[messageData.length - 1].content === "") {
                    const lastMessage = messageData[messageData.length - 1];
                    const type = fileType(lastMessage.file_type);

                    switch (type) {
                        case "image":
                            chat.latestMessage = "New Image";
                            break;
                        case "video":
                            chat.latestMessage = "New Video";
                            break;
                        case "application":
                            chat.latestMessage = "New Document";
                            break;
                        case "unknown":
                            chat.latestMessage = "New Attachment";
                            break;
                        default:
                            chat.latestMessage = "New File";
                            break;
                    }
                }
                chatArray.push(chat);
            }

            const contactsArray = Array.from(allContacts.values());
            await Promise.all(
                contactsArray.map(async (contact) => {
                    const response = await fetch(`${baseUrl}/profilePictureById`, {
                        method: "GET",
                        headers: { user_id: contact.userId }
                    });
                    const profilePic = await response.json();
                    contact.profilePic = profilePic;
                })
            );
            setGeneralContacts(contactsArray);
            setChats(chatArray);
            setPreChangeGroup(chatArray);

        } catch (error) {
        }
        setLoadingGroups(false);
    }

    function close() {
        try {
            document.getElementById("modifyRecipientsContainer").style.display = "none";
        } catch { }
        document.getElementById('startChatBackground').style.display = 'none';
        document.getElementById('changeChatBackground').style.display = 'none';
    }

    function addChat() {
        setRecipientAddError("");
        document.getElementById('startChatBackground').style.display = 'block';
        chat_name.current.value = "";
    }

    // ✅ FIXED: Use null instead of "defaultProf.avif"
    async function makeGroup(secureFilename = null) {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                group_name: chatName,
                chat_logo: secureFilename, // ✅ Will be null if no image uploaded
                creator_id: activeUser
            }),
        };

        const response = await fetch(`${baseUrl}/groups`, requestOptions);
        const data = await response.json();
        const adminResponse = await fetch(`${baseUrl}/makeAdmin`, {
            method: "POST",
            headers: {
                user_id: activeUser,
                group_id: data.group_id
            },
        });

        if (adminResponse.ok) {
        } else {
        }
        return data;
    }

    async function uploadToR2Direct(file, fileType = 'image') {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('file_type', fileType);
            formData.append('user_id', activeUser);
            formData.append('group_id', activeGroupId);

            const response = await fetch(`${baseUrl}/upload/direct`, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.detail || 'Upload failed');
            }

            const data = await response.json();
            return {
                filename: data.filename,
                original_filename: data.original_filename,
                url: data.public_url,
                size: data.size,
                status: 'success',
                metadata_id: data.metadata_id
            };

        } catch (error) {
            throw error;
        }
    }

    // ✅ FIXED: handleSubmit now passes null if no image
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            let secureFilename = null; // ✅ Start with null

            if (chatImage !== null) {
                const uploadResult = await uploadToR2Direct(chatImage, 'image');
                secureFilename = uploadResult.filename;
            }

            const group = await makeGroup(secureFilename);
            addRecipients(group.group_id);

        } catch (error) {
            alert("Failed to create group: " + error.message);
        }
    }

    async function addRecipients(group_id) {
        for (let i = 0; i < recipients.length; i++) {
            const element = recipients[i];
            const response = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: group_id,
                    user_id: element
                })
            });
            if (response.ok) {
            } else {
            }
        }
        const response = await fetch(`${baseUrl}/addRecipient`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                group_id: group_id,
                user_id: activeUser
            })
        });
        if (response.ok) {
        } else {
        }
        window.location.reload();
    }

    const uploadImage = async (file) => {
        try {
            const uploadResult = await uploadToR2Direct(file, 'image');
            return uploadResult.filename;
        } catch (error) {
            alert("Failed to upload image: " + error.message);
            return null;
        }
    };

    async function handleAddRecipient(e) {
        e.preventDefault();
        try {
            const response = await fetch(`${baseUrl}/getUsernameById`, {
                headers: {
                    user_id: activeUser
                }
            })
            const loggedInUsername = await response.json();
            try {
                const response = await fetch(`${baseUrl}/userIdByUsername`, {
                    headers: {
                        username: recipient
                    }
                })
                const data = await response.json();
                if ((recipientsUsernames.includes(recipient)) || (loggedInUsername.username === recipient)) {
                    setAddRecipientsResponse("User already added.");
                }
                if (data === null) {
                    setAddRecipientsResponse("Error please try again.");
                }
                if ((data != null) && (!recipientsUsernames.includes(recipient)) && (loggedInUsername.username !== recipient)) {
                    setRecipientsUsernames([...recipientsUsernames, recipient]);
                    setRecipients([...recipients, data]);
                    recipientInp.current.value = "";
                    setAddRecipientsResponse("");
                }
            } catch (error) {
                setAddRecipientsResponse("Error please try again.");
            }
        }
        catch {

        }
    }

    async function showMessage(n, admins) {
        setIsAdmin(false);
        if (admins.includes(activeUser)) {
            setIsAdmin(true);
        }
        document.getElementById('detailsContainer').style.height = '72vh';
        document.getElementById("input").style.display = 'block';
        document.getElementById('messengerLandingMessage').style.display = 'none';
        let popups = document.getElementsByClassName("profilePopup");
        for (let i = 0; i < popups.length; i++) {
            const element = popups[i];
            element.style.display = "none"
        }
        let details = document.getElementsByClassName("chatDetails");
        for (let i = 0; i < details.length; i++) {
            const element = details[i];
            element.style.display = "none"
        }
        try {
            if (!(document.getElementById("chatDetails" + n).style.display = "grid")) {
                console.error("element not found.")
            }
            else {
                document.getElementById("chatDetails" + n).style.display = "grid";
            }
        } catch { }
        setActiveGroupId(n);
        getMessages(n);
        if (detailsOpen) {
            showProfile("profilePopup" + n)
        }
        setMessageError(null);
    }

    function showProfile(n) {
        setRecipientAddError("");
        let members = document.getElementsByClassName("members");
        let open = document.getElementsByClassName("open");
        let close = document.getElementsByClassName("close");
        if (detailsOpen) {
            document.getElementById(n).style.display = 'none';
            for (let i = 0; i < members.length; i++) {
                const element = members[i];
                element.style.display = "block";
                close[i].style.display = "none";
                open[i].style.display = "block";
            }
            setDetailsOpen(false);
        }
        else {
            document.getElementById(n).style.display = 'block';
            for (let i = 0; i < members.length; i++) {
                const element = members[i];
                element.style.display = "none";
                close[i].style.display = "block";
                open[i].style.display = "none";
            }
            setDetailsOpen(true);
        }
    }

    function openSettings(group_id, group_name, chat, chatIndex) {
        setRecipientAddError("");
        document.getElementById('changeChatBackground').style.display = 'block';
        if (detailsOpen) {
            showProfile("profilePopup" + group_id);
        }
        chat_name.current.value = group_name;
        groupID.current.value = group_id;
        currentChat.push(chat);
        setCurrentChatIndex(chatIndex);
    }

    const changeGroup = async () => {
        try {
            uploadImage(chatImage);
            const requestOptions = {
                method: "PUT",
                headers: {
                    group_id: groupID.current.value,
                    group_name: chatName,
                    group_logo: chatImage.name
                }
            };
            const response = await fetch(`${baseUrl}/changeGroup`, requestOptions);
            const data = await response.json();
            return data;
        }
        catch {

        }
    }

    async function deleteUser(user_id, group_id, chatIndex, index) {
        const response = await fetch(`${baseUrl}/removeRecipient`, {
            method: "DELETE",
            headers: {
                user_id: user_id,
                group_id: group_id
            },
        })
        if (response.ok) {
        } else {
        }
        const c = chats.map((chat) => {
            return chat;
        });
        c[chatIndex].recipients.splice(index, index + 1);
        setChats(c);
    }

    async function leaveGroup(user_id, group_id) {
        const response = await fetch(`${baseUrl}/removeRecipient`, {
            method: "DELETE",
            headers: {
                user_id: user_id,
                group_id: group_id
            },
        })
        if (response.ok) {
        } else {
        }
        window.location.reload();
    }

    async function removeAdmin(user_id, group_id, chatIndex, index) {
        const c = chats.map((chat) => {
            return chat;
        });
        c[chatIndex].recipients[index].isAdmin = false;
        setChats(c);
        if (chats[chatIndex].creator_id === user_id) {
            setIsAdmin(false);
        }
        const response = await fetch(`${baseUrl}/removeAdmin`, {
            method: "DELETE",
            headers: {
                user_id: user_id,
                group_id: group_id
            },
        })
        if (response.ok) {
        } else {
        }
    }

    async function addRecipient(group_id, chatIndex) {
        setRecipientAddError("");
        try {
            if (recipientInput.current[chatIndex].value === "") {
                setRecipientAddError("Input left blank.");
            }
            else {
                const responseData = await fetch(`${baseUrl}/userIdByUsername`, {
                    headers: {
                        username: recipientInput.current[chatIndex].value
                    }
                })
                const data = await responseData.json();
                if (data == null) {
                    setRecipientAddError("User does not exist.");
                }
                else {
                    try {
                        const response = await fetch(`${baseUrl}/addRecipient`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                group_id: group_id,
                                user_id: data
                            })
                        });
                        if (response.ok) {
                        } else {
                        }
                        const admins = await fetch(`${baseUrl}/isAdmin`, {
                            headers: {
                                user_id: data,
                                group_id: group_id
                            }
                        })
                        let result = await admins.json();
                        const c = chats.map((chat) => {
                            return chat;
                        });
                        c[chatIndex].recipients.push({
                            userId: data,
                            isAdmin: result,
                            username: recipientInput.current[chatIndex].value
                        });
                        setChats(c);
                        recipientInput.current[chatIndex].value = "";
                    }
                    catch {
                        setRecipientAddError("User already in group.");
                    }
                }
            }
        }
        catch {
            setRecipientAddError("There was an error adding a recipient please check your input and try again.");
        }
    }

    useEffect(() => {
        recipientInput.current = recipientInput.current.slice(0, chats.length);
    }, [chats]);

    try {
        // ✅ FIXED: chatDetails with generated avatars
        chatDetails = chats.map((chat, chatIndex) =>
            <div className="chatDetails" key={chat.group_id} keyprop={chat.group_id} id={"chatDetails" + chat.group_id}>
                {/* ✅ Show uploaded logo OR generated avatar */}
                {chat.chat_logo ? (
                    <img src={`${R2_PUBLIC_URL}/img/${chat.chat_logo}`} alt="" className='chatDetailsAvi' />
                ) : (
                    <div className='chatDetailsAvi' style={{ overflow: 'hidden' }}>
                        {generateGroupAvatar(chat.group_name)}
                    </div>
                )}
                <p>{chat.group_name}</p>
                {isAdmin && <IoIosSettings id='settings' onClick={() => { openSettings(chat.group_id, chat.group_name, chat, chatIndex) }} />}
                <IoMdArrowDropright className='open' onClick={() => { showProfile("profilePopup" + chat.group_id) }} />
                <IoMdArrowDropdown className='close' onClick={() => { showProfile("profilePopup" + chat.group_id) }} />
                <p className='members'>Members: {chat.recipients.length > 0 ? chat.recipients[0].username : ""}  {chat.recipients.length >= 2 ? ", " + chat.recipients[1].username : ""}{chat.recipients.length > 2 ? " ..." : ""}</p>
                <div className='profilePopup' id={'profilePopup' + chat.group_id} key={chat.group_id}>
                    <p id='memberTitle'>Creator: {
                        chat.recipients.map(
                            recipient => {
                                if (recipient.userId === chat.creator_id) {
                                    return recipient.username
                                }
                            }
                        )
                    }</p>
                    {chat.recipients.length > 1 && <p id='memberTitle'>Members:</p>}
                    {chat.recipients.map(
                        (recipient, index) =>
                            recipient.userId !== chat.creator_id &&
                            <>
                                <div className='recipient' key={index}>
                                    {isAdmin && !recipient.isAdmin && <FaPlus className="addAdmin" onClick={() => {
                                        makeAdmin(recipient.userId, chat.group_id, chatIndex, index);
                                    }} />}
                                    {isAdmin && recipient.isAdmin && <FaMinus className="removeAdmin" onClick={() => {
                                        removeAdmin(recipient.userId, chat.group_id, chatIndex, index);
                                    }} />}
                                    {chats[chatIndex].recipients[index].isAdmin}
                                    <p>{recipient.username}</p>
                                    {isAdmin && <MdDelete id='userDelete' onClick={() => { deleteUser(recipient.userId, chat.group_id, chatIndex, index) }} />}
                                </div>
                                <hr />
                            </>
                    )}
                    {recipientAddError !== "" && <p id='recipientAddError'>{recipientAddError}</p>}
                    {isAdmin && <div className='AddUser'>
                        <input type="text" ref={el => recipientInput.current[chatIndex] = el} />
                        <FaPlus className="addUserSubmit" onClick={() => { addRecipient(chat.group_id, chatIndex) }} />
                    </div>}
                    <div id='leaveButton'>
                        {chat.creator_id !== activeUser && <button id='leaveGroup' onClick={() => { leaveGroup(activeUser, chat.group_id) }}>Leave Group</button>}
                    </div>
                </div>
            </div>
        );

        // ✅ FIXED: chatItems with generated avatars
        chatItems = chats.slice().reverse().map(chat =>
            <>
                <div className="chats" key={chat.group_id} keyprop={chat.group_id} id={chat.group_id} onClick={() => { showMessage(chat.group_id, chat.admins) }}>
                    {/* ✅ Show uploaded logo OR generated avatar */}
                    {chat.chat_logo ? (
                        <img src={`${R2_PUBLIC_URL}/img/${chat.chat_logo}`} alt="" className='chatAvi' />
                    ) : (
                        <div className='chatAvi' style={{ overflow: 'hidden' }}>
                            {generateGroupAvatar(chat.group_name)}
                        </div>
                    )}
                    <p className="chatName">{chat.group_name}</p>
                </div>
                <p className='messagePreview' onClick={() => { showMessage(chat.group_id, chat.admins) }}>{chat.latestMessage}</p>
                <hr />
            </>
        );
    }
    catch {
    }

    const recipientSettings = currentChat.map((chat, chatIndex) =>
        <div id='modifyRecipientsContainer'>
            <h2 id='modifyRecipients'>Modify Recipients:</h2>
            {chat.recipients.map(
                (recipient, index) =>
                    recipient.userId !== activeUser &&
                    <div className='recipient' key={index}>
                        {isAdmin && !recipient.isAdmin && <FaPlus className="addAdmin" onClick={() => {
                            makeAdmin(recipient.userId, chat.group_id, currentChatIndex, index);
                        }} />}
                        {isAdmin && recipient.isAdmin && <FaMinus className="removeAdmin" onClick={() => {
                            removeAdmin(recipient.userId, chat.group_id, currentChatIndex, index);
                        }} />}
                        {chats[currentChatIndex].recipients[index].isAdmin}
                        <p>{recipient.username}</p>
                        {isAdmin && <MdDelete id='userDelete' onClick={() => { deleteUser(recipient.userId, chat.group_id, currentChatIndex, index) }} />}
                    </div>
            )}
            <p id='recipientAddError'>{recipientAddError}</p>
            {isAdmin && <div className='AddUser'>
                <input type="text" ref={el => recipientInput.current[chatIndex] = el} />
                <FaPlus className="addUserSubmit" onClick={() => { addRecipient(chat.group_id, chatIndex) }} />
            </div>}
        </div>
    )

    async function getMessages(group_id) {
        const response = await fetch(`${baseUrl}/getMessage`, {
            headers: {
                group_id: group_id
            },
        });
        const data = await response.json();
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.from_id === activeUser) {
                element.class = 'messengerSenderMe';
            }
            else {
                const username = await fetch(`${baseUrl}/getUsernameById`, {
                    headers: {
                        user_id: element.from_id,
                    }
                });
                const usernameData = await username.json();
                element.from_username = usernameData.username;
                element.class = 'messengerSenderOther';

                const profPic = await fetch(`${baseUrl}/profilePictureById`, {
                    method: "GET",
                    headers: {
                        user_id: element.from_id,
                    },
                })
                const ProfilePicdata = await profPic.json();
                element.profilePic = ProfilePicdata;
            }
            if (i === data.length - 1) {
                element.lastMessage = true;
                const response = await fetch(`${baseUrl}/getReadReceipts`, {
                    headers: {
                        group_id: element.group_id
                    },
                });
                const data = await response.json();
                element.read = data;
                if (element.from_id !== activeUser && !(element.read)) {
                    const readReceipt = await fetch(`${baseUrl}/addReadReceipt`, {
                        method: "POST",
                        headers: {
                            group_id: group_id,
                            user_id: activeUser
                        },
                    });
                    if (readReceipt.ok) {
                        element.read = true;
                    }
                    else {
                    }
                }
            }
        }
        setMessages(data);
    }

    function fileType(file) {
        if (!file || file === null || file === "null" || file === "") {
            return "unknown";
        }
        try {
            let fileType = file.split("/");
            return fileType[0];
        } catch (error) {
            return "unknown";
        }
    }

    function showPopup(msg_id) {
        document.getElementById('fileSizeHover' + msg_id).style.display = 'block';
    }

    function hidePopup(msg_id) {
        document.getElementById('fileSizeHover' + msg_id).style.display = 'none';
    }

    async function deleteMessage(msg_id) {
        try {
            const response = await fetch(`${baseUrl}/deleteMessage`, {
                method: "DELETE",
                headers: {
                    message_id: msg_id,
                },
            });

            if (response.ok) {
                setMessageError(null);
                await getMessages(activeGroupId);

                const messages = await fetch(`${baseUrl}/getMessage`, {
                    headers: {
                        group_id: activeGroupId
                    },
                });

                const messageData = await messages.json();

                if (messageData.length > 0) {
                    const lastMessage = messageData[messageData.length - 1];
                    let chatList = [...chats];

                    for (let i = 0; i < chatList.length; i++) {
                        if (activeGroupId === chatList[i].group_id) {
                            chatList[i].latestMessage = lastMessage.content || "New Attachment";
                            break;
                        }
                    }

                    setChats(chatList);
                } else {
                    let chatList = [...chats];
                    for (let i = 0; i < chatList.length; i++) {
                        if (activeGroupId === chatList[i].group_id) {
                            chatList[i].latestMessage = null;
                            break;
                        }
                    }
                    setChats(chatList);
                }

            } else {
                setMessageError('Message delete failed');
                setTimeout(() => { setMessageError(null) }, 3500);
            }
        } catch (error) {
            setMessageError('Error deleting message');
            setTimeout(() => { setMessageError(null) }, 3500);
        }
    }

    const MessageList = React.memo(() => {
        try {
            // Group messages by date with proper formatting
            const groupedMessages = {};
            for (let i = 0; i < messages.length; i++) {
                const element = messages[i];

                const dateKey = isToday(new Date(element.send_date))
                    ? "Today"
                    : isYesterday(new Date(element.send_date))
                        ? "Yesterday"
                        : format(new Date(element.send_date), "MMMM d, yyyy");

                if (!groupedMessages[dateKey]) {
                    groupedMessages[dateKey] = [];
                }
                groupedMessages[dateKey].push(element);
            }

            return (
                <div>
                    {Object.keys(groupedMessages).map((dateKey) => (
                        <div key={dateKey}>
                            <h4 className='dateKey'><span>{dateKey}</span></h4>
                            {groupedMessages[dateKey].map((msg, index) => (
                                <React.Fragment key={msg.message_id}>
                                    <div id={msg.group_id + '.' + msg.message_id} className={msg.class}>
                                        {msg.class !== "messengerSenderMe" && (
                                            <span>
                                                <img
                                                    src={msg.profilePic || `${baseUrl}/static/img/defaultProf.avif`}
                                                    alt={msg.from_username}
                                                    className='senderProfilePic'
                                                    style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
                                                    onError={(e) => {
                                                        e.target.src = `${baseUrl}/static/img/defaultProf.avif`;
                                                    }}
                                                />
                                                <strong>{msg.from_username}</strong>
                                            </span>
                                        )}
                                        {msg.class !== "messengerSenderMe" && <div id={'fileSizeHover' + msg.message_id} className='fileSizeHover'>
                                            <p>File size: {byteSize(msg.file_size).value}{byteSize(msg.file_size).unit}</p>
                                        </div>}

                                        {/* Image messages */}
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && fileType(msg.file_type) === "image" && <img className='messageImg' src={`${R2_PUBLIC_URL}/img/${msg.file}`} alt='' />}
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && msg.class === "messengerSenderMe" && fileType(msg.file_type) === "image" &&
                                            <details className='fileSettingIconContainer'>
                                                <summary className='fileSettingIcon'><BsThreeDotsVertical /></summary>
                                                <div className='fileDropdown'>
                                                    <p>File size: {byteSize(msg.file_size).value}{byteSize(msg.file_size).unit}</p>
                                                    <hr />
                                                    <p onClick={() => handleDownload(`${R2_PUBLIC_URL}/img/${msg.file}`, msg.file)}>Download</p>
                                                    <hr />
                                                    <p onClick={() => { deleteMessage(msg.message_id) }}>Delete</p>
                                                </div>
                                            </details>
                                        }
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && fileType(msg.file_type) === "image" && msg.class === "messengerSenderOther" &&
                                            <div
                                                className='fileDownloadIcon'
                                                onClick={() => handleDownload(`${R2_PUBLIC_URL}/img/${msg.file}`, msg.file)}
                                                onMouseOut={() => { hidePopup(msg.message_id) }}
                                                onMouseOver={() => { showPopup(msg.message_id) }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <IoMdDownload />
                                            </div>
                                        }

                                        {/* Video messages */}
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && fileType(msg.file_type) === "video" && <video className='messageVid' src={`${R2_PUBLIC_URL}/vid/${msg.file}`} controls />}
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && msg.class === "messengerSenderMe" && fileType(msg.file_type) === "video" &&
                                            <details className='fileSettingIconContainer'>
                                                <summary className='fileSettingIcon'><BsThreeDotsVertical /></summary>
                                                <div className='fileDropdown'>
                                                    <p>File size: {byteSize(msg.file_size).value}{byteSize(msg.file_size).unit}</p>
                                                    <hr />
                                                    <p onClick={() => handleDownload(`${R2_PUBLIC_URL}/vid/${msg.file}`, msg.file)}>Download</p>
                                                    <hr />
                                                    <p onClick={() => { deleteMessage(msg.message_id) }}>Delete</p>
                                                </div>
                                            </details>
                                        }
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && fileType(msg.file_type) === "video" && msg.class === "messengerSenderOther" &&
                                            <div
                                                className='fileDownloadIcon'
                                                onClick={() => handleDownload(`${R2_PUBLIC_URL}/vid/${msg.file}`, msg.file)}
                                                onMouseOut={() => { hidePopup(msg.message_id) }}
                                                onMouseOver={() => { showPopup(msg.message_id) }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <IoMdDownload />
                                            </div>
                                        }

                                        <p>{msg.content}</p>

                                        {/* Document messages */}
                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" && fileType(msg.file_type) === "application" &&
                                            <div className="document-preview-container">
                                                <div className="document-preview-box">
                                                    {msg.file_type === "application/pdf" ? (
                                                        <PDFPreview
                                                            file={`${R2_PUBLIC_URL}/doc/${msg.file}`}
                                                            filename={msg.file}
                                                        />
                                                    ) : (
                                                        <>
                                                            <SiGoogledocs className='documentPreviewIcon' />
                                                            <p className='documentFileName'>{msg.file}</p>
                                                        </>
                                                    )}
                                                    {msg.class === "messengerSenderMe" &&
                                                        <details className='fileSettingIconContainer'>
                                                            <summary className='fileSettingIcon'><BsThreeDotsVertical /></summary>
                                                            <div className='fileDropdown'>
                                                                <p>File size: {byteSize(msg.file_size).value}{byteSize(msg.file_size).unit}</p>
                                                                <hr />
                                                                <p onClick={() => handleDownload(`${R2_PUBLIC_URL}/doc/${msg.file}`, msg.file)}>Download</p>
                                                                <hr />
                                                                <p onClick={() => { deleteMessage(msg.message_id) }}>Delete</p>
                                                            </div>
                                                        </details>
                                                    }
                                                    {msg.class === "messengerSenderOther" &&
                                                        <div
                                                            className='fileDownloadIcon'
                                                            onClick={() => handleDownload(`${R2_PUBLIC_URL}/doc/${msg.file}`, msg.file)}
                                                            onMouseOut={() => { hidePopup(msg.message_id) }}
                                                            onMouseOver={() => { showPopup(msg.message_id) }}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <IoMdDownload />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }

                                        {msg.file !== undefined && msg.file !== null && msg.file !== "null" &&
                                            <p className="creationDate">{msg.lastMessage && msg.read && <FaRegCheckCircle id='readReceiptIcon' />}{msg.send_date.split("T")[1]}</p>}
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    ))}
                </div>
            );
        }
        catch { }
    });

    const sendMessage = async (e) => {
        setFile(null);
        e.preventDefault();

        const readReceipt = await fetch(`${baseUrl}/deleteReadReceipt`, {
            method: "DELETE",
            headers: {
                group_id: activeGroupId
            },
        });

        if (readReceipt.ok) {
            console.log("Read receipts remove success.")
        } else {
            console.log("Read receipts remove failure.")
        }

        if (messageFile !== null && activeGroupId in messageFile) {
            let uploadedFilename = null;
            let fileType = 'image';
            let file = messageFile[activeGroupId];

            if (file.type.startsWith('video/')) {
                fileType = 'video';
            } else if (file.type.startsWith('application/') || file.type.includes('document')) {
                fileType = 'document';
            }
            try {
                const uploadResult = await uploadToR2Direct(file, fileType);
                uploadedFilename = uploadResult.filename;
                setMessageError(null);
            } catch (error) {
                setMessageError(`${fileType} upload failed`);
                setTimeout(() => { setMessageError(null) }, 3500);
                return;
            }

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    from_id: activeUser,
                    content: content,
                    group_id: activeGroupId,
                    file: uploadedFilename,
                    file_type: messageFile[activeGroupId].type,
                    file_size: messageFile[activeGroupId].size,
                })
            };

            const response = await fetch(`${baseUrl}/message`, requestOptions);

            if (response.ok) {
                setMessageError(null);
            } else {
                setMessageError('Message send failed');
                setTimeout(() => { setMessageError(null) }, 3500);
            }

            setMessageFile(null);
        }
        else if (content && content.trim() !== "") {
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    from_id: activeUser,
                    content: content,
                    group_id: activeGroupId,
                    file: null,
                    file_type: null,
                    file_size: 0,
                })
            };

            const response = await fetch(`${baseUrl}/message`, requestOptions);

            if (response.ok) {
                setMessageError(null);
            } else {
                setMessageError('Message send failed');
                setTimeout(() => { setMessageError(null) }, 3500);
            }
        }

        getMessages(activeGroupId);
        messageContents.current.value = "";
        setContent("");

        const messageDate = await fetch(`${baseUrl}/changeLastMessage`, {
            method: "PUT",
            headers: {
                group_id: activeGroupId
            }
        });

        if (messageDate.ok) {
            console.log("Message date change success.")
        }

        const messages = await fetch(`${baseUrl}/getMessage`, {
            headers: {
                group_id: activeGroupId
            },
        });

        const messageData = await messages.json();

        if (messageData.length > 0) {
            var lastMessage = messageData[messageData.length - 1];
            let chatList = [...chats];

            for (let i = 0; i < chatList.length; i++) {
                const element = chatList[i];
                if (activeGroupId === element.group_id) {
                    element.latestMessage = lastMessage.content || "New Attachment";
                    break;
                }
            }

            setChats(chatList);
        }
    }

    // ✅ FIXED: Use null instead of "defaultProf.avif"
    async function startChatParam(userId) {
        setStartChatError("");
        try {
            const user_Id = await fetch(`${baseUrl}/getUserIDByToken`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
            });

            const id = await user_Id.json();

            const username = await fetch(`${baseUrl}/getUsernameById`,
                {
                    headers: { "user_id": userId }
                }
            )
            const usernameResponse = await username.json();
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_name: "Chat With " + usernameResponse.username,
                    chat_logo: null, // ✅ Use null instead of "defaultProf.avif"
                    creator_id: id.user_id
                }),
            };
            const response = await fetch(`${baseUrl}/groups`, requestOptions);
            const data = await response.json();
            const adminResponse = await fetch(`${baseUrl}/makeAdmin`, {
                method: "POST",
                headers: {
                    user_id: id.user_id,
                    group_id: data.group_id
                },
            })
            if (adminResponse.ok) {
            } else {
            }
            if (response.ok) {
            } else {
                throw new Error();
            }
            const responseRecipients = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: data.group_id,
                    user_id: id.user_id
                })
            });
            if (responseRecipients.ok) {
            } else {
                throw new Error();
            }
            const responseRecipients2 = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: data.group_id,
                    user_id: userId
                })
            });
            if (responseRecipients2.ok) {
            } else {
                throw new Error();
            }
            getGroups();
            setTimeout(async function () { showMessage(await data.group_id, [activeUser]) }, 3500);
            searchResultInp.current.value = "";
            setSearchResults("");
        }
        catch {
            setStartChatError("Error starting chat with user, please check username and try again.");
        }
    }

    // ✅ FIXED: Use null instead of "defaultProf.avif"
    async function startChatSearch() {
        setStartChatError("");
        try {
            const userNameResponse = await fetch(`${baseUrl}/userIdByUsername`, {
                headers: {
                    username: searchResults
                }
            })
            const userNameData = await userNameResponse.json();
            if (userNameData === null) {
                throw new Error();
            }
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_name: "Chat With " + searchResults,
                    chat_logo: null, // ✅ Use null instead of "defaultProf.avif"
                    creator_id: activeUser
                }),
            };
            const response = await fetch(`${baseUrl}/groups`, requestOptions);
            const data = await response.json();
            const adminResponse = await fetch(`${baseUrl}/makeAdmin`, {
                method: "POST",
                headers: {
                    user_id: activeUser,
                    group_id: data.group_id
                },
            })
            if (adminResponse.ok) {
            } else {
            }
            if (response.ok) {
            } else {
                throw new Error();
            }
            const responseRecipients = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: data.group_id,
                    user_id: activeUser
                })
            });
            if (responseRecipients.ok) {
            } else {
                throw new Error();
            }
            const responseRecipients2 = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: data.group_id,
                    user_id: userNameData
                })
            });
            if (responseRecipients2.ok) {
            } else {
                throw new Error();
            }
            getGroups();
            setTimeout(async function () { showMessage(await data.group_id, [activeUser]) }, 3500);
            searchResultInp.current.value = "";
            setSearchResults("");
        }
        catch {
            setStartChatError("Error starting chat with user, please check username and try again.");
        }
    }

    async function deleteChat() {
        const response = await fetch(`${baseUrl}/deleteGroup`, {
            method: "DELETE",
            headers: {
                group_id: groupID.current.value
            },
        })
        if (response.ok) {
        } else {
        }
    }

    tippy('#chatsAddBtn', {
        content: "Create Group"
    });

    tippy('#userDelete', {
        content: "Remove user from group"
    });

    tippy('.addAdmin', {
        content: "Make user admin"
    });

    tippy('.removeAdmin', {
        content: "Remove admin"
    })

    tippy('#settings', {
        content: "Open settings"
    })

    tippy('#contactsButton', {
        content: "Open Contacts"
    })

    tippy("#openChatsButton", {
        content: "Open Groups"
    })

    useEffect(
        () => {
            getGroups();
        }, [setChats]
    )

    function filterGroupsBySearch() {
        let c = preChangeGroup.map(
            chat => {
                const regex = new RegExp(searchResults);
                if (regex.test(chat.group_name)) {
                    return chat;
                }
            }
        )
        setChats(c);
        if (c[0] === undefined) {
            setGroupResults(0);
        }
        else {
            setGroupResults(1);
        }
    }

    function checkContacts(contactList, recipient) {
        if (contactList.length > 0) {
            for (let i = 0; i < contactList.length; i++) {
                const element = contactList[i];
                if (element.userId === recipient.userId) {
                    return false;
                }
            }
        }
        else {
            return true;
        }
    }

    async function searchUsers() {
        let tempResults = [];
        if (searchResults !== "") {
            const response = await fetch(`${baseUrl}/searchableUserList`, {
                method: "GET",
                headers: {
                    input: searchResults
                },
            })
            const data = await response.json();
            if (data.length > 0) {
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    if (element.user_id !== activeUser && !(contacts.includes(element.user_id))) {
                        tempResults.push(element);
                        const response = await fetch(`${baseUrl}/profilePictureById`, {
                            method: "GET",
                            headers: {
                                user_id: element.user_id,
                            },
                        })
                        const data = await response.json();
                        element.profilePic = data;
                    }
                }
            }
            setUserSearch(tempResults);
        }
    }

    // ✅ FIXED: Use null instead of "defaultProf.avif"
    async function startChatSearchSpecific(user_id, username) {
        setStartChatError("");
        try {
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_name: "Chat With " + username,
                    chat_logo: null, // ✅ Use null instead of "defaultProf.avif"
                    creator_id: activeUser
                }),
            };
            const response = await fetch(`${baseUrl}/groups`, requestOptions);
            const data = await response.json();
            const adminResponse = await fetch(`${baseUrl}/makeAdmin`, {
                method: "POST",
                headers: {
                    user_id: activeUser,
                    group_id: data.group_id
                },
            })
            if (adminResponse.ok) {
            } else {
            }
            if (response.ok) {
            } else {
                throw new Error();
            }
            const responseRecipients = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: data.group_id,
                    user_id: activeUser
                })
            });
            if (responseRecipients.ok) {
            } else {
                throw new Error();
            }
            const responseRecipients2 = await fetch(`${baseUrl}/addRecipient`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    group_id: data.group_id,
                    user_id: user_id
                })
            });
            if (responseRecipients2.ok) {
            } else {
                throw new Error();
            }
            getGroups();
            setTimeout(async function () { showMessage(await data.group_id, [activeUser]) }, 3500);
            searchResultInp.current.value = "";
            setSearchResults("");
        }
        catch {
            setStartChatError("Error starting chat with user, please try again.");
        }
    }

    const searchResultList = userSearch.map(
        user =>
            <div key={user.user_id} id={user.user_id} className='userSearchResults' onClick={() => { startChatSearchSpecific(user.user_id, user.username) }}  >
                <img
                    src={user.profilePic || `${baseUrl}/static/img/defaultProf.avif`}
                    alt=""
                    className='contactImg'
                    onError={(e) => {
                        e.target.src = `${baseUrl}/static/img/defaultProf.avif`;
                    }}
                />
                <p>{user.username}</p>
            </div>
    )

    async function filterRecipientsBySearch() {
        let tempContacts = [];
        preChangeGroup.map(
            chat => {
                chat.recipients.map(
                    recipient => {
                        const regex = new RegExp(searchResults);
                        if (regex.test(recipient.username) && recipient.userId !== activeUser && checkContacts(tempContacts, recipient)) {
                            tempContacts.push(recipient);
                        }
                    }
                )
            }
        )
        for (let i = 0; i < tempContacts.length; i++) {
            const element = tempContacts[i];
            const response = await fetch(`${baseUrl}/profilePictureById`, {
                method: "GET",
                headers: {
                    user_id: element.userId,
                },
            })
            const data = await response.json();
            element.profilePic = data;
        }
        setContacts([...tempContacts]);
    }

    function previewClear() {
        setFile(null);
        setMessageFile(null);
        imgUpload.current.value = "";
    }

    // ✅ FIXED: contactList with generated group avatars
    const contactList = contacts.map(contact => (
        <div id={contact.userId} key={contact.userId}>
            <div className='contact'>
                <img
                    src={contact.profilePic || `${baseUrl}/static/img/defaultProf.avif`}
                    alt=""
                    className='contactImg'
                    onError={(e) => {
                        e.target.src = `${baseUrl}/static/img/defaultProf.avif`;
                    }}
                />
                <p>{contact.username}</p>
            </div>
            <div>
                <p className='subSections'>Shared Chats</p>
                <div id='results'>
                    {preChangeGroup.filter(chat =>
                        chat.recipients.some(recipient =>
                            contact.username === recipient.username
                        )
                    ).map(chat => (
                        <div
                            className="chats"
                            key={chat.group_id}
                            onClick={() => showMessage(chat.group_id, chat.admins)}
                        >
                            {/* ✅ Show uploaded logo OR generated avatar */}
                            {chat.chat_logo ? (
                                <img
                                    src={`${R2_PUBLIC_URL}/img/${chat.chat_logo}`}
                                    alt=""
                                    className='chatAvi'
                                />
                            ) : (
                                <div className='chatAvi' style={{ overflow: 'hidden' }}>
                                    {generateGroupAvatar(chat.group_name)}
                                </div>
                            )}
                            <p className="chatName">Chat Name: {chat.group_name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ));

    // ✅ FIXED: generalContactList with generated group avatars
    const generalContactList = generalContacts.map(contact => (
        <div id={contact.userId} key={contact.userId}>
            <div className='contact'>
                <img
                    src={contact.profilePic || `${baseUrl}/static/img/defaultProf.avif`}
                    alt=""
                    className='contactImg'
                    onError={(e) => {
                        e.target.src = `${baseUrl}/static/img/defaultProf.avif`;
                    }}
                />
                <p>{contact.username}</p>
            </div>
            <div>
                <p className='subSections'>Shared Chats</p>
                <div id='results'>
                    {chats.filter(chat => {
                        try {
                            return chat.recipients.some(recipient =>
                                contact.username === recipient.username
                            );
                        } catch {
                            return false;
                        }
                    }).map(chat => (
                        <div
                            className="chats"
                            key={chat.group_id}
                            onClick={() => showMessage(chat.group_id, chat.admins)}
                        >
                            {/* ✅ Show uploaded logo OR generated avatar */}
                            {chat.chat_logo ? (
                                <img
                                    src={`${R2_PUBLIC_URL}/img/${chat.chat_logo}`}
                                    alt=""
                                    className='chatAvi'
                                />
                            ) : (
                                <div className='chatAvi' style={{ overflow: 'hidden' }}>
                                    {generateGroupAvatar(chat.group_name)}
                                </div>
                            )}
                            <p className="chatName">Chat Name: {chat.group_name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ));

    useEffect(
        () => {
            if (searchResults !== "") {
                setSearchLoading(false);
                getGroups();
                setTimeout(() => {
                    setStartChatError("");
                    filterGroupsBySearch();
                    filterRecipientsBySearch();
                    searchUsers();
                    setSearchLoading(true);
                }, 3500);
            }
        }, [searchResults]
    )

    function openChats() {
        setContactsOpen(false);
    }

    function openContacts() {
        setContactsOpen(true);
    }

    const LoadingSpinner = () => (
        <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
    );

    function previewLarge() {
        let preview = document.getElementById("previewBlur");
        if (previewOpen) {
            preview.style.display = "none";
            setPreviewOpen(false);
        } else {
            preview.style.display = "flex";
            setPreviewOpen(true)
        }
    }

    return (
        <>
            <SubNav />
            <div id='previewBlur' onClick={() => { previewLarge() }}>
                {file !== null && (
                    (fileType(messageFile[activeGroupId].type) === "image" && (
                        <img id="previewLarge" alt="" src={file} onClick={() => previewLarge()} />
                    )) ||
                    (fileType(messageFile[activeGroupId].type) === "video" && (
                        <video id="previewLarge" alt="" src={file} onClick={() => previewLarge()} autoPlay controls />
                    ))
                )}
            </div>
            <main id="Messenger">
                <div id='chats'>
                    <div id='searchContainer'>
                        <input type="search" placeholder='Search' id='recipientSearchBar' ref={searchResultInp} onChange={(e) => { setSearchResults(e.target.value) }} />
                        <HiMiniMagnifyingGlass id="searchMag" />
                    </div>
                    {searchResults === "" && <MdGroupAdd onClick={addChat} id='chatsAddBtn' />}
                    {searchResults === "" && !(contactsOpen) && <TiContacts onClick={openContacts} id='contactsButton' />}
                    {searchResults === "" && contactsOpen && <BsChatSquareText onClick={openChats} id="openChatsButton" />}
                    <div id="searchResults">
                        {searchResults !== "" && searchLoading && groupResults > 0 && <p className='sections'>Groups</p>}
                        {searchResults === "" && loadingGroups && <LoadingSpinner id='Loading' />}
                        {searchResults !== "" && searchLoading && chatItems}
                        {searchResults !== "" && searchLoading && contacts[0] !== undefined && <p className='sections'>Contacts</p>}
                        {searchResults !== "" && searchLoading && contacts[0] !== undefined && contactList}
                        {searchResults !== "" && searchLoading && userSearch[0] !== undefined && <p className='sections'>Users</p>}
                        {searchResults !== "" && searchLoading && userSearch[0] !== undefined && searchResultList}
                        {searchResults !== "" && searchLoading && <p id='startChatError'>{startChatError}</p>}
                        {searchResults !== "" && searchLoading && <p id='startChatButton' onClick={() => { startChatSearch() }} >Start a chat with {searchResults}</p>}
                        {searchResults !== "" && !searchLoading && <LoadingSpinner id='searchLoading' />}
                        <div id='searchButtonContainer'>
                            {searchResults !== "" && <MdGroupAdd onClick={addChat} id='chatsAddBtn' />}
                            {searchResults !== "" && <TiContacts onClick={openContacts} id='contactsButton' />}
                        </div>
                    </div>
                    <div id="chatItemsList">
                        {searchResults === "" && !(contactsOpen) && chatItems}
                    </div>
                    <div id='contactsList'>
                        {searchResults === "" && contactsOpen && generalContactList}
                    </div>
                </div>
                <div id='chatContents'>
                    <div id='messengerMessages'>
                        <div id="detailsContainer">
                            {chatDetails}
                            <div id='messengerLandingMessage'>
                                <p>Click a chat from the left menu or type someones username in the search bar in the left group menu to start a chat.</p>
                            </div>
                            <div className='messageList'>
                                <MessageList />
                            </div>
                            {file !== null && <div id='uploadPreview'>
                                {fileType(messageFile[activeGroupId].type) === "image" && <img id="preview" alt="" src={file} onClick={() => { previewLarge() }} />}
                                {fileType(messageFile[activeGroupId].type) === "video" && <video id="preview" alt="" src={file} onClick={() => { previewLarge() }} />}
                                {fileType(messageFile[activeGroupId].type) === "application" && messageFile[activeGroupId].type === "application/pdf" &&
                                    <PDFPreview
                                        file={file}
                                        filename={messageFile[activeGroupId].name}
                                    />
                                }
                                {fileType(messageFile[activeGroupId].type) === "application" && messageFile[activeGroupId].type !== "application/pdf" &&
                                    <div className="pdf-preview-box">
                                        <SiGoogledocs className="pdf-preview-icon" />
                                        <p className="pdf-preview-name">{messageFile[activeGroupId].name}</p>
                                    </div>
                                }
                                <IoMdCloseCircleOutline id='previewClear' onClick={() => { previewClear() }} />
                            </div>}
                            {messageError !== null && messageError !== "" && <p id='messageError'>{messageError}</p>}
                        </div>
                    </div>
                    <div id='input'>
                        <form onSubmit={sendMessage}>
                            <textarea name="input" id="messengerChat" placeholder='Input your message here.' onChange={handleContentChange} ref={messageContents} />
                            <label>
                                <MdUpload id="uploadFile" />
                                <input type="file" name="file" id={"fileupload" + activeGroupId} ref={imgUpload} className='fileUploadInp' onChange={
                                    (e) => {
                                        if (e.target.files[0].size > 10485760) {
                                            setMessageError("File is too big!");
                                            setTimeout(() => { setMessageError(null) }, 3500);
                                            e.target.value = "";
                                        }
                                        else {
                                            setMessageError(null);
                                            setMessageFile(prevDict => ({ ...prevDict, [activeGroupId]: e.target.files[0] }));
                                            setFile(URL.createObjectURL(e.target.files[0]));
                                        }
                                    }
                                } />
                            </label>
                            <label>
                                <IoMdSend id='messengerSend' />
                                <button type="submit" id='messengerButton'></button>
                            </label>
                        </form>
                    </div>
                </div>
                <div id='startChatBackground'>
                    <div id='startChat'>
                        <form onSubmit={handleSubmit}>
                            <IoMdCloseCircleOutline id='startChatClose' onClick={close} />
                            <input type="text" name="chatName" id="chatName" placeholder='Chat Name' onChange={(e) => setChatName(e.target.value)} required />
                            <div>
                                <input type="text" name="recipient" id="recipient" placeholder='Recipient' onChange={(e) => setRecipient(e.target.value)} ref={recipientInp} />
                                <button onClick={(e) => { handleAddRecipient(e) }}>Add</button>
                            </div>
                            <div>
                                <p>{addRecipientResponse}</p>
                                <p>Recipients:</p>
                                {recipientsUsernames.map((username, index) => (
                                    <p key={index}>{username}</p>
                                ))}
                            </div>
                            <label For="chatLogo" id='chatLogoButton'>Select a group logo</label>
                            <div>
                                <input type="file" name="chatLogo" id="chatLogo" onChange={(e) => {
                                    if (e.target.files[0].size > 10485760) {
                                        alert("File is too big!");
                                        e.target.value = "";
                                    }
                                    else {
                                        setChatImage(e.target.files[0])
                                    }
                                }}
                                    accept='image/png, image/jpeg, image/gif' />
                                {chatImage !== null && <p>{chatImage.name}</p>}
                            </div>
                            <button onClick={close} type="submit">Start Group</button>
                        </form>
                    </div>
                </div>
                <div id='changeChatBackground'>
                    <div id='changeChat'>
                        <form onSubmit={changeGroup}>
                            <IoMdCloseCircleOutline id='startChatClose' onClick={close} />
                            <input type="text" name="chatName" id="chatName" placeholder='Chat Name' onChange={(e) => setChatName(e.target.value)} ref={chat_name} />
                            {recipientSettings}
                            <label For="chatLogo" id='chatLogoButton'>Select a group logo</label>
                            <div>
                                <input type="file" name="chatLogo" id="chatLogo" onChange={(e) => {
                                    if (e.target.files[0].size > 10485760) {
                                        alert("File is too big!");
                                        e.target.value = "";
                                    }
                                    else {
                                        setChatImage(e.target.files[0])
                                    }
                                }}
                                    accept='image/png, image/jpeg, image/gif' />
                                {chatImage !== null && <p>{chatImage.name}</p>}
                            </div>
                            <button onClick={close} type="submit">Change Group</button>
                            <button onClick={deleteChat} id='deleteChat' type='submit'>Delete Group</button>
                            <input type="number" name="group_id_Change" id="group_id_Change" ref={groupID} />
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
}
